import { OptionsService } from '../services/options-service';
import DependenciesInjector from '../helpers/dependencies-injector';
import { Dependencies } from '../interfaces/dependencies-types';
export class LoaderController implements Dependencies{
    private _loader: Element;
    private loaderInsideString = '<div id="overlay-obf"></div><div class="loader-obf"><div class="centered"> <div id="loader-wrapper-obf"><div id="inner-loader-obf" class="loading-obf"></div><div class="loader-section-obf section-left-obf"></div><div class="loader-section-obf section-right-obf"></div></div></div></div>';

    private optionsService: OptionsService;

    public async initialize() {
        this.optionsService = await DependenciesInjector.getRegistered('OptionsService') as OptionsService;

        this.changeLoaderSpinnersColor();

        this.appendCss();
        this._loader = this.createLoaderElement();
    }

    private createLoaderElement() {
        const element: Element = window.document.createElement('div');
        element.classList.add('obf-Loader');
        element.innerHTML = this.loaderInsideString;
        window.document.body.appendChild(element);
        return element;
    }

    private appendCss() {
        if (document.querySelector('obf-loader-style')) {
            return;
        }

        const element: Element = window.document.createElement('style');

        element.innerHTML = `.obf-Loader { position: fixed; z-index: 99999999999; top: 0; display: none; left: 0; right: 0; bottom: 0; } .obf-Loader.show { display: block; } #inner-loader-obf.loading-obf { display: block; position: relative; left: 50%; top: 50%; width: 50px; height: 50px; margin: -25px 0 0 -25px; border-radius: 50%; border: 2px solid transparent; border-top-color: #949494; border-top-color: var(--client-loader-outside-circle); -webkit-animation: spin-obf 1s linear infinite; animation: spin-obf 1s linear infinite; z-index: 1001; } #inner-loader-obf.loading-obf:before { content: \'\'; position: absolute; top: 3px; left: 3px; right: 3px; bottom: 3px; border-radius: 50%; border: 2px solid transparent; border-top-color: #c9c9c9; border-top-color: var(--client-loader-middle-circle); -webkit-animation: spin-obf 1.6s linear infinite; animation: spin-obf 1.6s linear infinite; } #inner-loader-obf.loading-obf:after { content: \'\'; position: absolute; top: 8px; left: 8px; right: 8px; bottom: 8px; border-radius: 50%; border: 2px solid transparent; border-top-color: #ffffff; border-top-color: var(--client-loader-inside-circle); -webkit-animation: spin-obf 0.8s linear infinite; animation: spin-obf 0.8s linear infinite; } @-webkit-keyframes spin-obf { 0% { -webkit-transform: rotate(0); -ms-transform: rotate(0); transform: rotate(0); } 100% { -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); transform: rotate(360deg); } } @keyframes spin-obf { 0% { -webkit-transform: rotate(0); -ms-transform: rotate(0); transform: rotate(0); } 100% { -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); transform: rotate(360deg); } } #loader-wrapper-obf .loader-section-obf { position: fixed; top: 0; width: 50%; height: 100%; z-index: 1000; -webkit-transform: translateX(0); -ms-transform: translateX(0); transform: translateX(0); } #loader-wrapper-obf .loader-section-obf.section-left-obf { left: 0; } #loader-wrapper-obf .loader-section-obf.section-right-obf { right: 0; } #overlay-obf { z-index: 1150; position: absolute; top: 0; left: 0; bottom: 0; right: 0; background-color: rgba(0, 0, 0, 0.5); } .loader-obf { z-index: 1200; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); } .loading-text-container-obf { color: #fff; z-index: 1200; margin-top: 15px; text-align: center; }`

        document.querySelector('head').appendChild(element);
        return;
    }

    public changeLoaderSpinnersColor() {

        const options = this.optionsService.getObfOptions();

        const outside = options?.theme && options.theme["loader-outside-circle"] ? options.theme["loader-outside-circle"] : '#949494';
        const middle = options?.theme && options.theme["loader-middle-circle"] ? options.theme["loader-middle-circle"] : '#c9c9c9';
        const inside = options?.theme && options.theme["loader-inside-circle"] ? options.theme["loader-inside-circle"] : '#ffffff';

        document.documentElement.style.setProperty('--client-loader-outside-circle', outside);
        document.documentElement.style.setProperty('--client-loader-middle-circle', middle);
        document.documentElement.style.setProperty('--client-loader-inside-circle', inside);
    }

    public getLoader() {
        return this._loader;
    }

    public openLoader() {

        this.changeLoaderSpinnersColor();

        this._loader.classList.add('show');
    }

    public closeLoader() {
        this._loader.classList.remove('show');
    }

    public closeWithDelay(delay: number) {
        setTimeout(() => {
            this._loader.classList.remove('show');
        }, delay);
    }
}
